import { render, staticRenderFns } from "./VideoCallSubScreenGridList.vue?vue&type=template&id=7efc2aa6&scoped=true&"
import script from "./VideoCallSubScreenGridList.vue?vue&type=script&lang=ts&"
export * from "./VideoCallSubScreenGridList.vue?vue&type=script&lang=ts&"
import style0 from "./VideoCallSubScreenGridList.vue?vue&type=style&index=0&id=7efc2aa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efc2aa6",
  null
  
)

export default component.exports